// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getExtractDate(
  extractDateParam: string | undefined,
  isStaffUser: boolean,
) {
  let extractDate = '';

  if (extractDateParam && isStaffUser) {
    extractDate = extractDateParam;
  }

  return extractDate;
}
